@if (loading) {
  <div class="userlist__progress-parent">
    <mat-progress-spinner
      class="userlist__progress"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>
}

<app-userlist-filter
  [opened]="openFilter"
  (openedChange)="onFilterPanelOpenedChange($event)"
  [filter]="filter"
  [allIndustries]="allIndustries"
  [allSkills]="allSkills"
  [allCatalogues]="allCatalogues"
  [allCertificates]="allCertificates"
  [allMainFocuses]="allMainFocuses"
  [allTrainings]="allTrainings"
  [advisorOptions]="advisorOptions"
  (apply)="applyFilters()"
  (reset)="resetFilters()"
>
  <div>
    <div>
      <app-sorter
        (isArchiving)="onArchiveClick($event)"
        (isListView)="onListView($event)"
        (sortBy)="onSort($event)"
        (searchValueChanged)="searchForUsers($event)"
        (searchScopeChanged)="onSearchScopeChange($event)"
        (opened)="onOpened($event)"
        (companyFilterChange)="onCompanyFilterChange($event)"
        (applicantFilterChange)="onApplicantFilterChange($event)"
        (freelancerFilterChange)="onFreelancerFilterChange($event)"
        class="app-sorter"
        [amount]="filterAmount"
        [sortValue]="filterState.sortColumn"
        [selectedCompany]="selectedCompany"
        [searchScope]="searchScope"
        [applicantOnly]="applicantOnly"
        [freelancerOnly]="freelancerOnly"
        [profilerLanguage]="activeProfilerLanguage"
        [completenessLevels]="completenessLevels"
        [completenessCounts]="completenessCounts"
        (completenessLevelsChange)="onCompletenessLevelsChange($event)"
      ></app-sorter>

      <div
        class="userlist__user-list"
        [ngClass]="{ 'userlist__user-list--list-view-active': listView }"
      >
        <p
          class="userlist__result-count"
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          @if (resultCount !== null) {
            {{ resultCountKey | translate: { count: resultCount } }}
          }
        </p>
        <span
          class="cdk-visually-hidden userlist__search-live"
          aria-live="polite"
          aria-atomic="true"
          >{{ searchAnnouncement }}</span
        >
        @for (user of users; track user) {
          @let profilerLanguage = profilerLanguageOf(user);
          <div
            class="userlist__user-card"
            tabindex="0"
            role="button"
            [routerLink]="['/profile', user.id]"
            [attr.data-consultant-name]="user | consultantName"
            [attr.aria-label]="
              cardAriaKey(profilerLanguage)
                | translate
                  : {
                      name: user | consultantName,
                      language:
                        profilerLanguageLabelKey(profilerLanguage) | translate,
                      completeness: completenessAria(user),
                    }
            "
          >
            <div class="userlist__user-main">
              <div class="userlist__avatar">
                <img
                  [lazyImage]="user.id"
                  [lazyImagePhotoId]="
                    user.photoIds?.length ? user.photoIds[0] : defaultPhoto
                  "
                  alt="{{ 'consultant.applicant.altTag' | translate }}"
                  (error)="onImageError($event)"
                  class="userlist__profile-pic"
                />
                @if (profilerLanguage) {
                  <span class="userlist__flag-badge">
                    <app-profiler-language-flag
                      [langKey]="profilerLanguage"
                    ></app-profiler-language-flag>
                  </span>
                }
              </div>

              <div class="userlist__user-info">
                <div class="userlist__badges">
                  @if (user?.firma) {
                    <app-company-badge
                      [abbreviation]="user.firma!"
                    ></app-company-badge>
                  }
                  @if (user?.applicant) {
                    <span class="userlist__applicant-badge">{{
                      'consultant.applicant.isApplicant' | translate
                    }}</span>
                  }
                  @if (user?.freelancer) {
                    <span class="userlist__freelancer-badge">{{
                      'consultant.freelancer.isFreelancer' | translate
                    }}</span>
                  }
                </div>

                <app-user-information
                  [label]="'userlist.content.name'"
                  [value]="user | consultantName"
                  [ngClass]="{ 'userlist__user-name': user.name }"
                ></app-user-information>

                <app-user-information
                  [label]="'userlist.content.position'"
                  [value]="user.position"
                ></app-user-information>

                <app-user-information
                  [label]="'userlist.content.available'"
                  [value]="user?.verfuegbar | date: 'dd.MM.yyyy'"
                  [customClass]="getAvailableClass(user?.verfuegbar)"
                ></app-user-information>

                <app-user-information
                  [label]="'userlist.content.language'"
                  [value]="createLanguageList(user)"
                ></app-user-information>

                <app-user-information
                  [label]="'userlist.content.travel'"
                  [value]="user.reisebereitschaft | travelWillingness"
                ></app-user-information>
              </div>
            </div>

            <div class="userlist__additional-control">
              <div
                class="userlist__hidden-check"
                [ngClass]="{ 'userlist__hidden-check--active': archiveMode }"
              >
                <mat-checkbox
                  type="checkbox"
                  (click)="$event.stopPropagation(); archiveThisPofile(user.id)"
                  [checked]="user.versteckt"
                ></mat-checkbox>
              </div>
            </div>

            <div class="userlist__bonus-actions">
              <app-bonus-actions
                [berater]="user"
                [openMenuId]="openMenuId"
                (toggleMenu)="onToggleMenu($event)"
                (closeMenu)="onCloseMenu()"
              ></app-bonus-actions>
            </div>

            @if (completenessOf(user); as completeness) {
              <app-completeness-meter
                class="userlist__completeness-slot"
                [completeness]="completeness"
                [compact]="listView"
              ></app-completeness-meter>
            }
          </div>
        }
        @if (resultsLoaded && users.length === 0 && hasRestriction) {
          <mat-card appearance="outlined" class="userlist__no-data">
            <mat-card-content>
              {{ 'userlist.content.noData' | translate }}
            </mat-card-content>
          </mat-card>
        }
      </div>
    </div>
  </div>
</app-userlist-filter>
